import { render, staticRenderFns } from "./myPromiseGoodsRegModal.vue?vue&type=template&id=8f1de222"
import script from "./myPromiseGoodsRegModal.vue?vue&type=script&lang=js"
export * from "./myPromiseGoodsRegModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports